import { useId, useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { Skeleton } from "@mui/material";
import { env } from "@/configs/configEnv/env";
import type { VerificacaoTurnstileLogin } from "../loginUnificado.types";
import clsx from "clsx";

// --------------------------------- TYPES ---------------------------------
type VerificacaoSegurancaLoginProps = {
	readonly verificacao: VerificacaoTurnstileLogin;
	readonly carregando: boolean;
	readonly action: "login" | "login_otp";
	readonly className?: string;
};

// ------------------------------- COMPONENT -------------------------------
export default function VerificacaoSegurancaLogin({
	verificacao,
	carregando,
	action,
	className,
}: Readonly<VerificacaoSegurancaLoginProps>) {
	// -------------------------------- STATES --------------------------------
	const [pronto, setPronto] = useState(false);
	const widgetId = useId();

	// -------------------------------- RETURN --------------------------------
	return (
		<div className={clsx("relative min-w-75", className)} aria-busy={carregando || !pronto}>
			<div className="relative w-full">
				{pronto ? null : <Skeleton variant="rounded" height={65} width="100%" />}

				<Turnstile
					className={pronto ? "w-full" : "absolute inset-0 w-full opacity-0"}
					id={widgetId}
					ref={verificacao.widgetRef}
					siteKey={env.VITE_TURNSTILE_KEY}
					options={{
						theme: "light",
						size: "flexible",
						action,
						language: "pt-br",
						responseField: false,
					}}
					onWidgetLoad={() => {
						verificacao.widgetCarregado();
						setPronto(true);
					}}
					onSuccess={verificacao.confirmarToken}
					onExpire={verificacao.invalidarToken}
					onError={verificacao.registrarErroWidget}
					onTimeout={verificacao.invalidarToken}
				/>
			</div>

			{verificacao.mensagemErro ? (
				<div className="mt-2 space-y-1">
					<button
						type="button"
						onClick={verificacao.renovar}
						disabled={carregando}
						className="cursor-pointer text-sm font-semibold text-[#504a99] disabled:cursor-not-allowed"
					>
						Tentar novamente
					</button>
				</div>
			) : null}
		</div>
	);
}
